import * as React from "react";

const SvgFlexBox = props => <svg viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={36} height={20} fill="none" /><rect x={1} y={1} width={34} height={18} rx={1} stroke="currentColor" strokeWidth={2} /><rect x={4.5} y={4.5} width={12.0667} height={11} rx={1.5} stroke="currentColor" /><rect x={19.4333} y={4.5} width={12.0667} height={11} rx={1.5} stroke="currentColor" /></svg>;

export default SvgFlexBox;